import React, { useEffect, useReducer } from "react";
import { terminReducer } from "app/hostingReducer";

const BillingCycleOptions = ({ termin, terminHandle, productsItem, pid, managedVpsPricing }) => {
  const [terminShow, terminDispatch] = useReducer(terminReducer, {
    monthly: false,
    quarterly: false,
    semiannually: false,
    annually: false,
    biennially: false,
    triennially: false,
  });

  // Buat array label termin
  const periodLabels = {
    monthly: "1 Bulan",
    quarterly: "3 Bulan",
    semiannually: "6 Bulan",
    annually: "1 Tahun",
    biennially: "2 Tahun",
    triennially: "3 Tahun",
  };

  useEffect(() => {
    const periods = [
      "monthly",
      "quarterly",
      "semiannually",
      "annually",
      "biennially",
      "triennially",
    ];
    
    // Untuk Managed VPS, gunakan managedVpsPricing (activeProd.pricing.IDR)
    // Untuk VPS biasa, gunakan productsItem.price
    const pricingSource = managedVpsPricing || productsItem.price;
    
    if (!pricingSource) {
      return;
    }

    periods.forEach((period) => {
      if (pricingSource.hasOwnProperty(period)) {
        const value = pricingSource[period];
        const isPromo = productsItem.promo && productsItem.promo.promocode !== "FREETRIALWPQW";
        let payload;
        if (managedVpsPricing) {
          // Managed VPS: aktif jika nilai ada dan tidak -1
          payload = value && value !== "-1.00" && parseFloat(value) > 0;
        } else {
          // VPS biasa: aktif jika nilai > 0 atau ada promo untuk monthly
          payload = +value > 0 || (period === "monthly" && isPromo);
        }
        terminDispatch({ type: `ENABLE_${period.toUpperCase()}`, payload });
      }
    });
  }, [productsItem, productsItem.price, productsItem.promo, managedVpsPricing, terminDispatch]);

  // Ambil hanya termin yang aktif
  const availablePeriods = Object.keys(terminShow).filter((period) => terminShow[period]);

  return (
    <div className="mt-3 mb-3">
      <label htmlFor="activePeriod" className="mb-2 fw-bold">
        Durasi
      </label>
      <select
        className="form-select"
        id="activePeriod"
        name="activePeriod"
        value={termin}
        onChange={terminHandle}
        style={{ width: "100%" }}
      >
        {availablePeriods.map((period) => (
          <option value={period} key={period}>
            {periodLabels[period]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BillingCycleOptions;
